import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LocationStrategy, HashLocationStrategy, CommonModule, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AttachListComponent } from './attach-list/attach-list.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { SnackbarModule } from 'ngx-snackbar';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { VisitorsListComponent } from './visitors-list/visitors-list.component';
import { RouterModule } from '@angular/router';
import { ScheduleVisitorComponent } from './schedule-visitor/schedule-visitor.component';
import { ConfigService } from './services/config.service';

export function initializeApp(configService: ConfigService) { return () => configService.loadConfig().toPromise(); }

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    AttachListComponent,
    VisitorsListComponent,
    ScheduleVisitorComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule,
    SnackbarModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModalModule,
    RouterModule,
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }, DatePipe, { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [ConfigService], multi: true } ],
  bootstrap: [AppComponent]
})
export class AppModule { }
